import { Form } from "antd";
import * as React from "react";
import ReportsStore from "../stores/ReportsStore";
import { observer } from "mobx-react-lite";
import ReportEditForm from "./ReportEditForm";
import AppModal from "../../common/components/AppModal";

type Props = {
    store: ReportsStore;
};

const ReportEditDialog: React.FC<Props> = ({ store }) => {
    const [form] = Form.useForm();

    return (
        <AppModal
            centered
            width={600}
            title={
                store.editDialogMode === "create"
                    ? "Publish report"
                    : "Edit report"
            }
            destroyOnClose
            closable={false}
            maskClosable={false}
            open={store.editReportDialogVisible}
            className="alpha-modal"
            cancelButtonTitle="Cancel"
            onCancelClick={() => {
                form.resetFields();
                store.setNewReportDialogVisibility(false);
            }}
            cancelButtonProps={{
                "data-id": "add-report-cancel",
            }}
            submitButtonTitle={
                store.editDialogMode === "create" ? "Publish" : "Save"
            }
            submitButtonProps={{
                "data-id": "add-report-submit",
                form: "edit-published-report-form",
            }}
        >
            <ReportEditForm store={store} form={form} />
        </AppModal>
    );
};

export default observer(ReportEditDialog);
